import React, { useState, useEffect, useMemo } from 'react';
import { REACT_ICONS, REACT_ICON_NAMES } from '../utils/reactIcons';
import './skill-form-modal.css';

const SkillForm = ({ skill, onSave, onCancel }) => {
  const [formData, setFormData] = useState({
    name: '',
    category: '',
    level: 3,
    icon: ''
  });

  const [errors, setErrors] = useState({});
  const [showSuggestions, setShowSuggestions] = useState(false);

  useEffect(() => {
    if (skill) {
      setFormData({
        name: skill.name || '',
        category: skill.category || '',
        level: skill.level ? Math.round(skill.level / 20) : 3,
        icon: skill.icon || ''
      });
    }
  }, [skill]);

  const IconPreview = REACT_ICONS[formData.icon] || REACT_ICONS.SiReact;

  const iconSuggestions = useMemo(() => {
    if (!formData.icon) return [];
    return REACT_ICON_NAMES
      .filter(i => i.toLowerCase().includes(formData.icon.toLowerCase()))
      .slice(0, 8);
  }, [formData.icon]);

  const validateForm = () => {
    const e = {};
    if (!formData.name.trim()) e.name = 'Required';
    if (!formData.category.trim()) e.category = 'Required';
    if (!REACT_ICONS[formData.icon]) e.icon = 'Invalid icon';
    setErrors(e);
    return Object.keys(e).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateForm()) onSave(formData);
  };

  return (
    <div className="sf-overlay">
      <div className="sf-modal">
        {/* HEADER */}
        <div className="sf-header">
          <div className="sf-header-icon">
            <IconPreview size={26} />
          </div>
          <div>
            <h3>{skill ? 'Edit Skill' : 'Add New Skill'}</h3>
            <p>Define technology, icon, and proficiency level</p>
          </div>
        </div>

        {/* FORM */}
        <form onSubmit={handleSubmit} className="sf-form">
          {/* NAME */}
          <div className="sf-field">
            <label>Skill Name</label>
            <input
              value={formData.name}
              placeholder="React.js / Next.js"
              onChange={e => setFormData({ ...formData, name: e.target.value })}
            />
            {errors.name && <span className="sf-error">{errors.name}</span>}
          </div>

          {/* CATEGORY */}
          <div className="sf-field">
            <label>Category</label>
            <input
              value={formData.category}
              placeholder="Frontend, Backend, DevOps"
              onChange={e => setFormData({ ...formData, category: e.target.value })}
            />
            {errors.category && <span className="sf-error">{errors.category}</span>}
          </div>

          {/* ICON */}
          <div className="sf-field">
            <label>Icon</label>

            <div className="sf-icon-input">
              <div className="sf-icon-preview">
                <IconPreview size={22} />
              </div>

              <input
                value={formData.icon}
                placeholder="SiReact"
                onChange={(e) => {
                  setFormData({ ...formData, icon: e.target.value });
                  setShowSuggestions(true);
                }}
              />
            </div>

            {showSuggestions && iconSuggestions.length > 0 && (
              <div className="sf-icon-dropdown">
                {iconSuggestions.map(icon => {
                  const Icon = REACT_ICONS[icon];
                  return (
                    <div
                      key={icon}
                      className="sf-icon-option"
                      onClick={() => {
                        setFormData({ ...formData, icon });
                        setShowSuggestions(false);
                      }}
                    >
                      <Icon size={18} />
                      <span>{icon}</span>
                    </div>
                  );
                })}
              </div>
            )}

            {errors.icon && <span className="sf-error">{errors.icon}</span>}
          </div>

          {/* LEVEL */}
          <div className="sf-field">
            <label>Proficiency Level</label>
            <div className="sf-level">
              <input
                type="range"
                min="1"
                max="5"
                value={formData.level}
                onChange={e =>
                  setFormData({ ...formData, level: +e.target.value })
                }
              />
              <span>{formData.level}/5</span>
            </div>
          </div>

          {/* ACTIONS */}
          <div className="sf-actions">
            <button
              type="button"
              className="sf-btn sf-btn-secondary"
              onClick={onCancel}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="sf-btn sf-btn-primary"
            >
              {skill ? 'Update Skill' : 'Create Skill'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default SkillForm;
